<template>
    <Popper hover placement="bottom">
        <img
            v-lazy-load
            class="giftImages__img"
            src="/nuxt-assets/images/lazy-load-error.svg"
            :data-src="item.images ?? item.icon"
            :alt="item.header"
        />
        <img
            v-lazy-load
            width="15"
            src="/nuxt-assets/images/lazy-load-error.svg"
            :data-src="`/nuxt-assets/images/icons/magnifier.svg`"
            class="giftImages__magnifier"
        />
        <template #content>
            <div class="giftImages__hoverWrap">
                <img
                    v-lazy-load
                    class="giftImages__hoverImg"
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    :data-src="item.images ?? item.icon"
                    :alt="item.header"
                />
            </div>
        </template>
    </Popper>
</template>

<script lang="ts">
import Popper from 'vue3-popper'

export default {
    components: {
        Popper,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.giftImages__img {
    width: auto;
    height: auto;
    max-width: 32px;
    max-height: 32px;
}
.giftImages__magnifier {
    position: absolute;
    right: 5px;
    bottom: 5px;
}
.giftImages__hoverWrap {
    width: 276px;
    height: 276px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.giftImages__hoverImg {
    width: auto;
    height: 100%;
    max-width: 236px;
    max-height: 236px;
}
</style>
